<template>
  <div class="complaint-suggestion">
    <div style="position: relative">
      <el-tabs v-model="activeTab" class="info-tabs">
        <el-tab-pane v-for="item in tabList" :key="item.name" :label="item.label" :name="item.name">
          <span slot="label">{{ item.label }}</span>
        </el-tab-pane>
      </el-tabs>
      <div class="btn-complaint" @click="openDialog">
        <img class="bianji" src="@/assets/image/bianji.png" />
        <div>写投诉/建议</div>
      </div>
    </div>
    <div class="bar-line"></div>

    <div class="info-table">
      <!-- 表头 -->
      <div class="table-row table-head">
        <div class="cell cell-publisher">反馈类型</div>
        <div class="cell cell-image" style="text-align: center">反馈内容</div>
        <div class="cell cell-name">反馈时间</div>
        <div class="cell cell-category">需求订单</div>
        <div class="cell cell-company">图片</div>
        <div class="cell cell-contact">处理时间</div>
        <div class="cell cell-status">状态</div>
        <div class="cell cell-action">操作</div>
      </div>

      <!-- 订单分组列表 -->
      <div v-if="loading" class="loading-wrap">加载中...</div>
      <div v-else-if="orderList.length === 0" class="empty-wrap">暂无数据</div>
      <div v-for="(order, index) in orderList" :key="index" class="order-group">
        <div class="order-id">反馈单号: {{ order.complaintAdviceId }}</div>
        <div class="table-row table-body">
          <div class="cell cell-publisher">{{ order.type === "complaint" ? "投诉" : "建议" }}</div>
          <div class="cell cell-image">{{ order.feedbackContent }}</div>
          <div class="cell cell-name">{{ order.createTime }}</div>
          <div class="cell cell-category">
            <span v-if="order.demandId" class="order-link" @click="goOrder(order.demandId)">查看订单</span>
            <span v-else>无</span>
          </div>
          <div class="cell cell-company">
            <template v-if="order.picture">
              <el-image :src="parsePictureList(order.picture)[0]" :preview-src-list="parsePictureList(order.picture)" fit="cover" class="product-img" />
            </template>
            <span v-else>无</span>
          </div>
          <div class="cell cell-contact">{{ order.completedTime || "无" }}</div>
          <div class="cell cell-status">{{ order.status === "wait" ? "待处理" : "已处理" }}</div>
          <div class="cell cell-action">
            <button v-if="order.status === 'wait'" class="op-btn" @click="cancelOrder(order.complaintAdviceId)">取消</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 投诉建议弹窗 -->
    <transition name="dialog-fade">
      <div v-if="dialogVisible" class="dialog-overlay" @click.self="dialogVisible = false">
        <div class="dialog-container">
          <!-- 标题栏 -->
          <div class="dialog-header">
            <span class="dialog-title">投诉建议</span>
            <img class="dialog-close" :src="closeIcon" @click="dialogVisible = false" />
          </div>

          <!-- 表单 -->
          <div class="dialog-form">
            <!-- 反馈类型 -->
            <div class="form-item" style="align-items: center">
              <label class="form-label">反馈类型<span class="required">*</span></label>
              <div class="type-options">
                <div class="type-option" :class="{ active: dialogForm.type === 'complaint' }" @click="dialogForm.type = 'complaint'">
                  <img :src="dialogForm.type === 'complaint' ? selected2Img : noSelected2Img" class="type-icon" />
                  <span>投诉</span>
                </div>
                <div class="type-option" :class="{ active: dialogForm.type === 'advice' }" @click="dialogForm.type = 'advice'">
                  <img :src="dialogForm.type === 'advice' ? selected2Img : noSelected2Img" class="type-icon" />
                  <span>建议</span>
                </div>
              </div>
            </div>
            <!-- 选择订单 -->
            <div v-if="dialogForm.type === 'complaint'" class="form-item" style="align-items: center" @click="selectOrder">
              <label class="form-label">选择订单<span class="required">*</span></label>
              <el-input v-model="dialogForm.demandOrderId" readonly placeholder="输入订单ID号/选择订单" class="form-input-dialog" prefix-icon="el-icon-search" />
            </div>

            <div class="form-item" v-if="selectedOrderRowData.demandId && selectedOrderRowData.demandId != '' && dialogForm.type === 'complaint'">
              <label class="form-label"></label>
              <div class="so-item-inner" style="border: 1px solid #dcdfe6; border-radius: 20px; padding: 11px 17px 30px 20px; margin: -10px 0 10px 0; flex: 1">
                <div class="so-item-header">
                  <div class="so-item-id">ID: {{ selectedOrderRowData.demandId }}</div>
                  <div>
                    <img class="so-item-radio" :src="selected2Img" />
                  </div>
                </div>
                <div class="so-item-user-row">
                  <div class="so-item-user-info">
                    <img class="so-item-avatar" :src="avatarImg" />
                    <span class="so-item-username">{{ selectedOrderRowData.appUser?.userName || "-" }}</span>
                  </div>
                  <div>
                    <div class="so-item-phone">{{ selectedOrderRowData.relationPhone }}</div>
                    <div class="so-item-company">{{ selectedOrderRowData.appUser?.enterpriseName }}</div>
                  </div>
                </div>
                <div class="so-item-product-name">产品名称：{{ selectedOrderRowData.productName || "-" }}</div>
                <div class="so-item-product-type">产品分类：{{ selectedOrderRowData.productType || "-" }}</div>
                <div class="so-item-product-remark">备注：{{ selectedOrderRowData.orderRemark || "-" }}</div>
              </div>
            </div>

            <!-- 反馈内容 -->
            <div class="form-item">
              <label class="form-label">反馈内容<span class="required">*</span></label>
              <el-input v-model="dialogForm.feedbackContent" type="textarea" :rows="4" placeholder="请输入" class="form-textarea" />
            </div>

            <!-- 联系方式 -->
            <div class="form-item" style="align-items: center">
              <label class="form-label">联系方式<span class="required">*</span></label>
              <el-input v-model="dialogForm.contactPhone" placeholder="请输入" maxlength="11" @input="dialogForm.contactPhone = dialogForm.contactPhone.replace(/\D/g, '')" class="form-input-dialog" />
            </div>

            <!-- 上传图片 -->
            <div class="form-item">
              <label class="form-label">上传图片</label>
              <image-upload v-model="dialogForm.picture" multiple :limit="5" dir="complaint" />
            </div>

            <!-- 提交按钮 -->
            <div style="text-align: center">
              <button class="dialog-submit" @click="handleComplaintSubmit">提交投诉建议</button>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <!-- 选择订单弹窗 -->
    <transition name="dialog-fade">
      <div v-if="selectOrderVisible" class="dialog-overlay" @click.self="selectOrderVisible = false">
        <div class="select-order-dialog">
          <div class="select-order-header">
            <span class="select-order-title">选择订单</span>
            <img class="dialog-close" :src="closeIcon" @click="selectOrderVisible = false" />
          </div>
          <div class="select-order-body" @scroll="handleSelectOrderScroll" v-loading="selectOrderLoading">
            <div v-if="selectOrderList.length === 0 && !selectOrderLoading" class="select-order-empty">暂无订单数据</div>
            <div
              v-for="(item, index) in selectOrderList"
              :key="index"
              class="select-order-item"
              :class="{ 'is-selected': selectedOrderId == String(item.demandId) }"
              @click="handleSelectOrderItem(item)"
            >
              <div class="so-item-inner">
                <div class="so-item-header">
                  <div class="so-item-id">ID: {{ item.demandId }}</div>
                  <div>
                    <img class="so-item-radio" :src="selectedOrderId == String(item.demandId) ? selected2Img : noSelected2Img" />
                  </div>
                </div>
                <div class="so-item-user-row">
                  <div class="so-item-user-info">
                    <img class="so-item-avatar" :src="avatarImg" />
                    <span class="so-item-username">{{ item.appUser?.userName || "-" }}</span>
                  </div>
                  <div>
                    <div class="so-item-phone">{{ item.relationPhone || "-" }}</div>
                    <div class="so-item-company">{{ item.appUser?.enterpriseName || "-" }}</div>
                  </div>
                </div>
                <div class="so-item-product-name">产品名称：{{ item.productName || "-" }}</div>
                <div class="so-item-product-type">产品分类：{{ item.productType || "-" }}</div>
                <div class="so-item-product-remark">备注：{{ item.orderRemark || "-" }}</div>
              </div>
            </div>
            <div v-if="selectOrderList.length > 0" class="select-order-loading-more">
              <span v-if="selectOrderLoadingMore">加载中...</span>
              <span v-else-if="selectOrderNoMore">— 没有更多了 —</span>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { getMyComplaintAdvice, addComplaintAdvice, cancelComplaintAdvice, getMyRelationOrder } from "@/api";
import ImageUpload from "@/components/ImageUpload.vue";

export default {
  name: "ComplaintSuggestion",
  components: { ImageUpload },
  data() {
    return {
      avatarImg: require("@/assets/image/avatar.png"),
      closeIcon: require("@/assets/image/close1-icon.png"),
      selected2Img: require("@/assets/image/selected2.png"),
      noSelected2Img: require("@/assets/image/no-selected2.png"),
      activeTab: "wait",
      tabList: [
        { name: "wait", label: "待处理" },
        { name: "completed", label: "已处理" },
      ],
      orderList: [],
      loading: false,
      dialogVisible: false,
      dialogForm: {
        type: "complaint",
        demandOrderId: "",
        feedbackContent: "",
        contactPhone: "",
        picture: [],
      },
      // 选择订单弹窗
      selectOrderVisible: false,
      selectOrderLoading: false,
      selectOrderList: [],
      selectedOrderId: "",
      selectedOrderRowData: {},
      selectOrderPageNum: 1,
      selectOrderPageSize: 5,
      selectOrderNoMore: false,
      selectOrderLoadingMore: false,
    };
  },
  watch: {
    activeTab: {
      immediate: true,
      handler() {
        this.fetchData();
      },
    },
    dialogVisible(val) {
      if (!val) {
        this.selectedOrderRowData = {};
      }
    },
  },
  methods: {
    selectOrder() {
      this.selectOrderVisible = true;
      // this.selectedOrderId = this.dialogForm.demandOrderId || "";
      this.selectOrderPageNum = 1;
      this.selectOrderList = [];
      this.selectOrderNoMore = false;
      this.fetchSelectOrderList();
    },
    fetchSelectOrderList() {
      const isFirstPage = this.selectOrderPageNum === 1;
      if (isFirstPage) {
        this.selectOrderLoading = true;
      } else {
        this.selectOrderLoadingMore = true;
      }
      getMyRelationOrder({
        pageNum: this.selectOrderPageNum,
        pageSize: this.selectOrderPageSize,
      })
        .then((res) => {
          this.selectOrderLoading = false;
          this.selectOrderLoadingMore = false;
          const rows = res.rows || [];
          if (isFirstPage) {
            this.selectOrderList = rows;
          } else {
            this.selectOrderList = this.selectOrderList.concat(rows);
          }
          this.selectOrderNoMore = rows.length < this.selectOrderPageSize;
        })
        .catch(() => {
          this.selectOrderLoading = false;
          this.selectOrderLoadingMore = false;
          if (isFirstPage) {
            this.selectOrderList = [];
          }
        });
    },
    handleSelectOrderScroll(e) {
      const { scrollTop, clientHeight, scrollHeight } = e.target;
      if (scrollTop + clientHeight >= scrollHeight - 10 && !this.selectOrderLoadingMore && !this.selectOrderNoMore) {
        this.selectOrderPageNum++;
        this.fetchSelectOrderList();
      }
    },

    handleSelectOrderItem(item) {
      this.selectedOrderId = item.demandId;
      this.selectedOrderRowData = item;
      this.dialogForm.demandOrderId = item.demandOrderId;
      this.selectOrderVisible = false;
    },
    fetchData() {
      this.loading = true;
      getMyComplaintAdvice({
        status: this.activeTab,
      })
        .then((res) => {
          this.loading = false;
          this.orderList = res.rows || [];
        })
        .catch(() => {
          this.loading = false;
          this.orderList = [];
        });
    },
    cancelOrder(complaintAdviceId) {
      this.$confirm("确定要取消该投诉/建议吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          cancelComplaintAdvice({
            complaintAdviceId,
            resultExplain: "取消了",
          })
            .then(() => {
              this.$message.success("取消成功");
              this.fetchData();
            })
            .catch((err) => {
              this.$message.error(err.message || "取消失败");
            });
        })
        .catch(() => {});
    },
    parsePictureList(picture) {
      if (!picture) return [];
      return picture.split(",").filter(Boolean);
    },
    goOrder(id) {
      this.$router.push(`/demand-detail/${id}`);
    },
    openDialog() {
      this.dialogVisible = true;
      this.resetDialogForm();
      this.selectedOrderId = "";
    },
    resetDialogForm() {
      this.dialogForm = {
        type: "complaint",
        demandOrderId: "",
        feedbackContent: "",
        contactPhone: "",
      };
    },
    handleComplaintSubmit() {
      if (this.dialogForm.type === "complaint" && !this.dialogForm.demandOrderId) {
        this.$message.warning("请选择订单");
        return;
      }
      if (!this.dialogForm.feedbackContent) {
        this.$message.warning("请输入反馈内容");
        return;
      }
      if (!this.dialogForm.contactPhone) {
        this.$message.warning("请输入联系方式");
        return;
      }
      if (!/^1[3-9]\d{9}$/.test(this.dialogForm.contactPhone)) {
        this.$message.warning("请输入正确的手机号");
        return;
      }

      const params = {
        type: this.dialogForm.type,
        demandOrderId: this.dialogForm.type === "advice" ? null : this.dialogForm.demandOrderId || null,
        feedbackContent: this.dialogForm.feedbackContent,
        relationPhone: this.dialogForm.contactPhone,
        picture: Array.isArray(this.dialogForm.picture) ? this.dialogForm.picture.join(",") : "",
        // demandId: this.selectedOrderRowData.demandId,
      };

      addComplaintAdvice(params)
        .then(() => {
          this.$message.success("提交成功");
          this.dialogVisible = false;
          this.fetchData();
        })
        .catch((err) => {
          this.$message.error(err.message || "提交失败");
        });
    },
  },
};
</script>

<style scoped>
.complaint-suggestion {
  background: #ffffff;
  border-radius: 8px;
  padding: 0 0px 27px 0px;
}
.info-tabs {
  padding: 0 38px;
}
.info-tabs >>> .el-tabs__item {
  font-size: 18px;
  color: #999999;
  height: 60px;
  line-height: 60px;
}

.info-tabs >>> .el-tabs__item.is-active {
  color: #1869ff;
  font-weight: 500;
}

.info-tabs >>> .el-tabs__active-bar {
  background-color: #1869ff;
}

.complaint-suggestion /deep/ .el-tabs__nav-wrap::after {
  height: 0;
}

.complaint-suggestion /deep/ .el-tabs__header {
  margin: 0;
}
.bar-line {
  width: 100%;
  height: 1px;
  background: #e5e5e5;
}

/* ---------- 表格区域 ---------- */
.info-table {
  padding: 0 20px;
  margin-top: 14px;
  font-size: 14px;
  color: #333333;
}

.table-row {
  display: flex;
  align-items: center;
  padding: 0 9px;
}

.cell {
  padding: 18px 8px 18px 0;
  box-sizing: border-box;
  word-break: break-all;
}

.cell-publisher {
  width: 9%;
  text-align: center;
}
.cell-image {
  width: 24%;
}
.cell-name {
  width: 10%;
  text-align: center;
}
.cell-category {
  text-align: center;
  width: 10%;
}
.cell-company {
  width: 15%;
  text-align: center;
}
.cell-contact {
  width: 12%;
  text-align: center;
}

.cell-status {
  width: 10%;
  text-align: center;
}
.cell-action {
  text-align: center;
  width: 10%;
}

/* 表头 */
.table-head {
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  font-size: 14px;
  color: #333333;
  background: #f7f7f7;
  padding: 10px 16px;
  margin-bottom: 6px;
}
.table-head .cell {
  padding: 0;
}

/* 订单分组 */
.order-group {
  border: 1px solid #ebebeb;
  border-radius: 2px;
  margin-bottom: 10px;
  overflow: hidden;
  line-height: 17px;
  color: #666666;
  font-weight: 400;
}

.order-id {
  background: #f7f7f7;
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  padding: 6px 9px;
  border-bottom: 1px solid #ebebeb;
}

.table-body {
  background: #ffffff;
}

/* 发布人 */
.avatar {
  width: 34px;
  height: 34px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 6px;
}

/* 产品图占位 */
.product-img {
  width: 48px;
  height: 48px;
  border-radius: 6px;
  margin-right: 4px;
  cursor: pointer;
}

/* 操作按钮 */
.op-btn {
  width: 80px;
  height: 30px;
  line-height: 28px;
  text-align: center;
  background: #ffffff;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  color: #333333;
  font-size: 13px;
  cursor: pointer;
  padding: 0;
}
.op-btn:hover {
  color: #1869ff;
  border-color: #1869ff;
}

.btn-complaint {
  width: 128px;
  height: 34px;
  color: #ffffff;
  background: #1869ff;
  border-radius: 4px 4px 4px 4px;
  position: absolute;
  right: 20px;
  top: 20px;
  font-size: 14px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.bianji {
  width: 20px;
  height: 20px;
  margin-right: 2px;
}

.loading-wrap,
.empty-wrap {
  text-align: center;
  padding: 40px 0;
  color: #999;
  font-size: 14px;
}

.order-link {
  color: #1869ff;
  cursor: pointer;
}
.order-link:hover {
  text-decoration: underline;
}

/* ========== 投诉建议弹窗 ========== */
.dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  z-index: 2000;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding-top: 10vh;
}

/* 渐变动画 */
.dialog-fade-enter-active,
.dialog-fade-leave-active {
  transition: opacity 0.3s ease;
}

.dialog-fade-enter,
.dialog-fade-leave-to {
  opacity: 0;
}

.dialog-container {
  width: 808px;
  max-height: 85vh;
  background: url("~@/assets/image/back.png") no-repeat top center;
  background-size: 100% 151px;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.dialog-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px 20px 0;
  flex-shrink: 0;
}

.dialog-title {
  font-size: 22px;
  font-weight: bold;
  color: #333;
}

.dialog-close {
  position: absolute;
  right: 28px;
  top: 28px;
  width: 34px;
  height: 34px;
  cursor: pointer;
}

.dialog-form {
  flex: 1;
  overflow-y: auto;
  min-height: 0;
  padding: 24px 40px 36px;
}

.dialog-form .form-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 20px;
  font-size: 18px;
}

.dialog-form .form-label {
  width: 100px;
  text-align: right;
  font-size: 18px;
  font-weight: 400;
  color: #000000;
  margin-right: 12px;
  flex-shrink: 0;
}

.required {
  color: #ff4d4f;
  margin-right: 2px;
}

/* 反馈类型选项 */
.type-options {
  display: flex;
  gap: 60px;
}

.type-option {
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-size: 18px;
  color: #666;
  transition: color 0.3s;
}

.type-option.active {
  color: #1869ff;
}

.type-icon {
  width: 20px;
  height: 20px;
}

/* 表单控件 */
.dialog-form /deep/ .el-input {
  font-size: 18px !important;
}
.form-select {
  flex: 1;
}
.form-select >>> .el-input__inner {
  color: #000;
  font-size: 18px;
  font-weight: 400;
}

.form-textarea >>> .el-textarea__inner {
  border-radius: 8px;
  font-size: 18px;
  color: #000;
  font-weight: 400;
  font-family: inherit;
}

.form-input-dialog >>> .el-input__inner {
  height: 44px;
  border-radius: 8px;
  font-size: 18px;
  color: #000000;
  font-weight: 400;
}

/* 提交按钮 */
.dialog-submit {
  width: 420px;
  height: 48px;
  background: #1869ff;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 18px;
  cursor: pointer;
  margin-top: 10px;
  transition: background 0.3s;
}

.dialog-submit:hover {
  background: #1456d4;
}

/* ========== 选择订单弹窗 ========== */
.select-order-dialog {
  width: 808px;
  background: url("~@/assets/image/back.png") no-repeat top center;
  background-size: 100% 151px;
  background-color: #fff;
  border-radius: 30px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.select-order-header {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  flex-shrink: 0;
}

.select-order-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
}

.select-order-body {
  flex: 1;
  overflow-y: auto;
  padding: 12px 20px;
  min-height: 200px;
  max-height: 700px;
}

.select-order-empty {
  text-align: center;
  padding: 60px 0;
  color: #999;
  font-size: 14px;
}

.select-order-item {
  background: #fff;
  border: 1px solid #eee;
  border-radius: 20px;
  padding: 11px 17px 30px 20px;
  margin-bottom: 12px;
  cursor: pointer;
  box-shadow: 0px 4px 4px 0px rgba(200, 200, 200, 0.25);
  transition: all 0.3s;
}

.select-order-item:hover {
  background: #f0f7ff;
}

.select-order-item.is-selected {
  border-color: #1869ff;
  background: #f0f7ff;
}

/* 订单卡片内部样式 */
.so-item-inner {
  font-size: 14px;
}

.so-item-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.so-item-id {
  font-weight: 400;
  color: #666666;
}

.so-item-radio {
  width: 27px;
  height: 27px;
}

.so-item-user-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 10px;
}

.so-item-user-info {
  display: flex;
  align-items: center;
}

.so-item-avatar {
  width: 44px;
  height: 44px;
}

.so-item-username {
  margin-left: 7px;
}

.so-item-phone {
  font-size: 18px;
  color: #333333;
  font-weight: bold;
}

.so-item-company {
  color: #999999;
  font-size: 12px;
}

.so-item-product-name {
  font-size: 20px;
  color: #333333;
}

.so-item-product-type {
  font-size: 14px;
  color: #999999;
  margin-top: 5px;
}

.so-item-product-remark {
  font-size: 14px;
  color: #999999;
  margin-top: 3px;
}

.select-order-loading-more {
  text-align: center;
  padding: 12px 0;
  color: #999;
  font-size: 13px;
}
</style>
